import React, { useState, useEffect } from "react";
import { Grid, Container } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import CustomButton from "../../components/Custom/CustomButton";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useFormValidation from "../../components/Custom/FormValidation";
import { buyerProfileValidationSchema } from "../../components/Custom/ValidationSchema";
const validationSchema = buyerProfileValidationSchema();
import { buyerProfile } from "../../Data/fieldData";
import CustomTextField from "../../components/Custom/CustomTextField";
import { useAlert } from "../../components/Alert";
import LoaderContainer from "../../components/LoaderContainer";
import SubmittingPopup from "../../components/Custom/FormSubmitPopup";
import { CustomTitle } from "../../components/Custom/CustomTypography";

export default function AddRequirement() {
  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { errors, validate } = useFormValidation(formData, validationSchema);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [toggleHandleChange, setToggleHandleChange] = useState(false);

  useEffect(() => {
    fetchBuyerDetails();
    setLoading(false);
  }, []);

  const fetchBuyerDetails = async () => {
    try {
      const result = await api.get(`/buyer/buyerdetails/`);
      if (result.status === 200) {
        setIsEdit(true);
        setFormData(result.data);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setIsEdit(false);
      } else {
        console.error("Error fetching buyer details:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    validate(formData);
    setToggleHandleChange(true);
    if (Object.keys(errors).length === 0) {
      setSubmitting(true);
      const updatedFormData = formData;

      const apiRequest = api.post("/buyer/buyerdetails/", updatedFormData);

      apiRequest
        .then((response) => {
          if (response && response.data) {
            showAlert(
              "success",
              isEdit ? "Updated Successfully" : "Details Added Successfully"
            );
            setSubmitting(false);
            setTimeout(() => {
              navigate("/");
            }, 1500);
          }
        })
        .catch((error) => {
          console.error("Error during submitting details:", error);
          setSubmitting(false);
          showAlert("error", "Error during submitting details");
        });
    } else {
      showAlert(
        "warning",
        "Please fix the validation errors before submitting."
      );
    }
  };

  const handleChange = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if (toggleHandleChange) {
      validate({ ...formData, [name]: value });
    }
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs" sx={{ mb: 3, marginTop: "20px" }}>
          <div>
            <Grid
              container
              justify="center"
              direction="column"
              style={{ marginTop: "10px" }}
            >
              <CustomTitle>
                {isEdit ? t("Update Profile") : t("Profile")}
              </CustomTitle>

              {buyerProfile.map((field) => (
                <React.Fragment key={field.name}>
                  {field.type === "text" && (
                    <CustomTextField
                      label={t(field.label)}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleChange}
                      type={field.type}
                      error={!!errors[field.name]}
                      helperText={errors[field.name]}
                      placeholder={field.placeholder}
                    />
                  )}

                  {field.type === "number" && (
                    <CustomTextField
                      label={t(field.label)}
                      name={field.name}
                      value={formData[field.name] || ""}
                      onChange={handleChange}
                      type={field.type}
                      error={!!errors[field.name]}
                      helperText={errors[field.name]}
                    />
                  )}
                </React.Fragment>
              ))}
              <CustomButton onClick={handleSubmit} hideIcon>
                {isEdit ? t("Update") : t("Save")}
              </CustomButton>
            </Grid>
          </div>
        </Container>
        {submitting && <SubmittingPopup />}
      </LoaderContainer>
    </>
  );
}
